import PlataformaLayout from "../../layout/plataformaLayout/plataformaLayout";

export default function plataforma () {
    return (
        <PlataformaLayout />
    )
}